export default {"src":"/_next/static/media/watch-minor.34bb6840.svg","height":78,"width":27};